module.exports = __webpack_public_path__ + "img/neirongnull.3aaba79f.png";